import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const ConfluenceIcon: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon {...props} customFill={preserveColor}>
    <g clipPath="url(#confluence-a)">
      <path
        fill="#1868DB"
        d="M4 10a6 6 0 0 1 6-6h12a6 6 0 0 1 6 6v12a6 6 0 0 1-6 6H10a6 6 0 0 1-6-6V10Z"
      />
      <mask
        id="confluence-b"
        width="14"
        height="12"
        x="9"
        y="10"
        maskUnits="userSpaceOnUse"
        style={{ maskType: 'luminance' }}
      >
        <path fill="#fff" d="M22.16 10.094H9.781v11.835h12.38V10.094Z" />
      </mask>
      <g mask="url(#confluence-b)">
        <path
          fill="#fff"
          d="M21.37 18.265c-3.704-1.79-4.785-2.058-6.346-2.058-1.83 0-3.391.761-4.785 2.902l-.229.35c-.187.288-.229.39-.229.514s.063.227.291.37l2.352 1.462c.124.083.228.124.332.124.125 0 .208-.062.333-.247l.375-.577c.582-.885 1.102-1.173 1.768-1.173.583 0 1.27.165 2.122.577l2.455 1.152c.25.124.52.062.645-.226l1.165-2.552c.125-.289.042-.474-.25-.618Zm-10.798-4.508c3.703 1.791 4.785 2.059 6.345 2.059 1.831 0 3.392-.762 4.786-2.902l.229-.35c.187-.289.228-.391.228-.515 0-.123-.062-.226-.29-.37l-2.352-1.462c-.125-.082-.229-.123-.333-.123-.125 0-.208.062-.333.247l-.374.576c-.583.885-1.103 1.173-1.769 1.173-.582 0-1.269-.164-2.122-.576l-2.455-1.153c-.25-.123-.52-.061-.645.227l-1.165 2.552c-.125.288-.041.473.25.617Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="confluence-a">
        <path fill="#fff" d="M4 4h24v24H4z" />
      </clipPath>
    </defs>
  </BaseIcon>
);
